import { useAtomValue } from "jotai";
import { devices } from "library/constants";
import { EBenefitContentTab } from "library/types";
import { benefitCardImageAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import styled from "styled-components";

import { BenefitSkeleton } from "components/Skeletons/BenefitSkeleton";
import { useBenefitsData } from "hooks/useBenefitsData";

import { AllBenefits } from "./AllBenefits";
import { EligiblePackages } from "./EligiblePackages";
import { EnrolledPackages } from "./EnrolledPackages";
import { ExpiredPackages } from "./ExpiredPackages";

export function BenefitsPageContent() {
  const { isLoading } = useBenefitsData();

  const selectedBenefitContentTab = useAtomValue(benefitContentTabAtom);
  const cardWithImage = useAtomValue(benefitCardImageAtom);

  return (
    <Wrap>
      {isLoading ? (
        <BenefitSkeleton isCardView cardWithImage={cardWithImage} />
      ) : (
        <>
          <Wrap>
            {selectedBenefitContentTab === EBenefitContentTab.all && <AllBenefits />}
            {selectedBenefitContentTab === EBenefitContentTab.eligible && <EligiblePackages />}
            {selectedBenefitContentTab === EBenefitContentTab.enrolled && <EnrolledPackages />}
            {selectedBenefitContentTab === EBenefitContentTab.expired && <ExpiredPackages />}
          </Wrap>
        </>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  box-sizing: border-box;
  padding: 1px;
  margin-top: 10px;
  // overflow-y: auto;
  @media only screen and ${devices.md} {
  }
`;
